<template>
  <div>
    <modal
      :name="modalName"
      :adaptive="true"
      :resizable="true"
      height="auto"
      :id="modalName"
    >
      <div class="icon icon-success"></div>
      <div class="title-success">{{$ml.with('VueJS').get(titleKey)}}</div>
      <div class="modal-text">{{$ml.with('VueJS').get(textKey)}}</div>
      <div class="modal-buttons">
        <a v-bind:href="'#/CatalogDetail/' + idCategory + '/' + idProduct" class="btn link-red">{{$ml.with('VueJS').get('understand')}}</a>
      </div>
    </modal>
  </div>
</template>
<script>
export default {
  props: {
    modalName: {
      type: String,
      default: 'success-request-equipment'
    },
    titleKey: {
      type: String,
      default: 'msgSuccessTitle'
    },
    textKey: {
      type: String,
      default: 'msgSuccessText'
    }
  },
  data () {
    return {
      idCategory: this.$route.params['idCategory'],
      idProduct: this.$route.params['idProduct']
    }
  }
}
</script>
